module.exports = __webpack_public_path__ + "img/ego.504e60e4.gif";